
import DefaultCell from "application/components/DefaultCell";

const operationURLS = {
  list: "/campaignSummary/list",
  csvDownload:"/campaignSummary/downloadCSV",
  pdfDownload: "/complaintDetail/generateAndDownloadPdf",
};

const getColumns = () => {
  return [
    {
      Header: "Lead Upload Date",
      accessor: "leadUploadDate",
      displayInList: true,
      allowInForm: false,
      allowFilter: true,
      dataType: "date",
      dateTime: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Campaign",
      accessor: "campaign",
      displayInList: true,
      allowInForm: false,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },

    {
      Header: "Total Upload",
      accessor: "upload",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "DNCL",
      accessor: "dnCl",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Total Duplicate",
      accessor: "duplicate",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "valid Upload",
      accessor: "validUpload",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Last Dial Date",
      accessor: "lastDialedOn",
      displayInList: true,
      allowInForm: false,
      allowFilter: true,
      dataType: "date",
      dateTime: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Dial Pending",
      accessor: "dialPending",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Total Answered",
      accessor: "answered",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Abandoned",
      accessor: "abondoned",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
  ];
};

export { getColumns, operationURLS };
